import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate } from 'react-router-dom';
import LeadsPage from './LeadsPage';
import OpportunitiesPage from './OpportunitiesPage';
import ContactsPage from './ContactsPage';
import CustomersPage from './CustomersPage';
import CampaignsPage from './CampaignsPage';
import SegmentsPage from './SegmentsPage';
import ForecastsPage from './ForecastsPage';
import QuotesPage from './QuotesPage';
import ProposalsPage from './ProposalsPage';
import AnalysesRapportsCrmPage from './AnalysesRapportsCrmPage';
import SalesAgentsPage from './SalesAgentsPage';
import ActivitiesPage from './ActivitiesPage';
import TasksPage from './TasksPage';
import InteractionsPage from './InteractionsPage';
import HistoryPage from './HistoryPage';
import MeetingsPage from './MeetingsPage';
import CallsPage from './CallsPage';
import EmailsPage from './EmailsPage';
import NotesPage from './NotesPage';
import SupportTicketsPage from './SupportTicketsPage';
import DocumentsPage from './DocumentsPage';
import SalesGoalsPage from './SalesGoalsPage';
import CrmConfigPage from './CrmConfigPage';
import CrmDashboardPage from './CrmDashboardPage';

/**
 * CRM module shell — routes aligned with saudiModuleStructure.js + interaction sub-pages.
 */
const CrmMainPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.crm.pages.crmMainPage.${key}`, opts);

  return (
    <div aria-label={p('title')}>
      <span className="sr-only">{p('subtitle')}</span>
      <Routes>
        <Route index element={<Navigate to="/crm/dashboard" replace />} />
        <Route path="/dashboard" element={<CrmDashboardPage />} />

        {/* Saudi module structure — primary sections */}
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/pipeline" element={<OpportunitiesPage />} />
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/contacts-accounts" element={<ContactsPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/clients" element={<CustomersPage />} />
        <Route path="/campaigns" element={<CampaignsPage />} />
        <Route path="/interactions" element={<InteractionsPage />} />
        <Route path="/sales-goals" element={<SalesGoalsPage />} />
        <Route path="/analyses-rapports" element={<AnalysesRapportsCrmPage />} />
        <Route path="/config" element={<CrmConfigPage />} />

        {/* Interaction & activity sub-routes */}
        <Route path="/sales-agents" element={<SalesAgentsPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/meetings" element={<MeetingsPage />} />
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/emails" element={<EmailsPage />} />
        <Route path="/notes" element={<NotesPage />} />

        {/* Extended CRM routes */}
        <Route path="/forecasting" element={<ForecastsPage />} />
        <Route path="/segmentation" element={<SegmentsPage />} />
        <Route path="/timeline" element={<HistoryPage />} />
        <Route path="/support-tickets" element={<SupportTicketsPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/prospects" element={<Navigate to="/crm/leads" replace />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/proposals" element={<ProposalsPage />} />
        <Route path="/reminders" element={<TasksPage />} />
        <Route path="/communications" element={<InteractionsPage />} />
        <Route path="/goals" element={<Navigate to="/crm/sales-goals" replace />} />

        <Route path="*" element={<Navigate to="/relation-client/clients" replace />} />
      </Routes>
    </div>
  );
};

export default CrmMainPage;
